import axios, { AxiosInstance, AxiosResponse } from 'axios';
import { API_BASE_URL } from '../../config';
import { store } from '../../app/store';
import { Asset } from '../../interfaces';
import { getAssetsByProjectId as fetchAssetsByProjectId } from '../../api/asset';

class ConsistencyListService {
  private token: string | undefined;
  private client: AxiosInstance | undefined;
  init() {
    const curStore = store.getState();
    this.token = curStore?.auth?.token;

    const headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: ''
    };
    if (this.token) {
      headers.Authorization = `Bearer ${this.token}`;
    }

    this.client = axios.create({
      baseURL: `${API_BASE_URL}`,
      headers: headers,
    });
    return this.client;
  }

  async getConsistencyProjects() {
    return this.init().get('/consistency/tian_hua', {
    });
  }

  async createConsistencyProject(name: string) {
    return this.init().post('/consistency/tian_hua', {
      name
    });
  }

  async deleteConsistencyProject(projectId: string) {
    return this.init().delete(`/consistency/tian_hua/${projectId}`);
  }

  /**
   * 获取项目完整的资源列表
   * @param projectId 项目ID
   */
  async getAssetsByProjectId(projectId: number): Promise<AxiosResponse<Asset[]>> {
    return fetchAssetsByProjectId(projectId);
  }
}

export default new ConsistencyListService();
